import { useEffect, useState } from "react";
import { api, fmtErr, fmtDateTime } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const STATUS_LABELS = { nouveau: "Nouveau", contacte: "Contacté", converti: "Converti", refuse: "Refusé" };
const STATUS_STYLES = {
  nouveau: "bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900",
  contacte: "bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200",
  converti: "bg-green-100 text-green-900 dark:bg-green-950 dark:text-green-300",
  refuse: "bg-red-100 text-red-900 dark:bg-red-950 dark:text-red-300",
};

export default function DemoRequestsPage() {
  const [requests, setRequests] = useState(null);

  const load = () => api.get("/demo-requests").then(({ data }) => setRequests(data)).catch((e) => toast.error(fmtErr(e)));
  useEffect(() => { load(); }, []);

  const setStatus = async (r, status) => {
    try {
      await api.patch(`/demo-requests/${r.id}`, { status });
      toast.success("Statut mis à jour");
      load();
    } catch (e) {
      toast.error(fmtErr(e));
    }
  };

  return (
    <div data-testid="demo-requests-page">
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">Demandes de démo</h1>
        <p className="mt-1 text-sm text-muted-foreground">Demandes reçues depuis la landing page publique.</p>
      </div>

      <div className="overflow-x-auto rounded-sm border border-border bg-card">
        {requests === null ? (
          <div className="p-10 text-center text-sm text-muted-foreground" data-testid="demo-requests-loading">Chargement…</div>
        ) : (
        <table className="w-full text-sm" data-testid="demo-requests-table">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-5 py-3 font-semibold">Date</th>
              <th className="px-5 py-3 font-semibold">Nom</th>
              <th className="px-5 py-3 font-semibold">Société</th>
              <th className="px-5 py-3 font-semibold">Contact</th>
              <th className="px-5 py-3 font-semibold">Secteur</th>
              <th className="px-5 py-3 font-semibold">Utilisateurs</th>
              <th className="px-5 py-3 font-semibold">Message</th>
              <th className="px-5 py-3 font-semibold">Statut</th>
            </tr>
          </thead>
          <tbody>
            {(requests || []).map((r) => (
              <tr key={r.id} className="border-b border-border last:border-b-0 hover:bg-accent transition-colors duration-200" data-testid={`demo-row-${r.id}`}>
                <td className="whitespace-nowrap px-5 py-3 text-xs text-muted-foreground">{fmtDateTime(r.created_at)}</td>
                <td className="px-5 py-3 font-medium">{r.name}</td>
                <td className="px-5 py-3">{r.company}</td>
                <td className="px-5 py-3">
                  <div className="text-xs">{r.email}</div>
                  <div className="text-xs text-muted-foreground">{r.phone || "—"}</div>
                </td>
                <td className="px-5 py-3 text-xs">{r.sector || "—"}</td>
                <td className="px-5 py-3 text-xs">{r.users_estimate || "—"}</td>
                <td className="max-w-56 truncate px-5 py-3 text-xs text-foreground/80" title={r.message}>{r.message || "—"}</td>
                <td className="px-5 py-3">
                  <Select value={r.status} onValueChange={(v) => setStatus(r, v)}>
                    <SelectTrigger data-testid={`demo-status-${r.id}`} className={`h-7 w-32 rounded-sm border-0 text-xs font-semibold ${STATUS_STYLES[r.status]}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {Object.entries(STATUS_LABELS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        )}
        {requests && requests.length === 0 && (
          <div className="p-10 text-center text-sm text-muted-foreground" data-testid="demo-requests-empty">
            Aucune demande de démo pour le moment.
          </div>
        )}
      </div>
    </div>
  );
}
